<div class="dialog-container">
  <div class="dialog-header" neoDialogTitleContainer>
    <div class="dialog-title-section">
      <h2 class="dialog-title" neoDialogTitle>SharePoint Document Storage</h2>
      <p class="dialog-subtitle">Configure your Microsoft SharePoint integration for secure document storage.</p>
    </div>
    <cm-button
      variant="basic"
      [iconOnly]="true"
      class="dialog-close"
      (click)="onCancel()"
      ariaLabel="Close dialog"
      tooltip="Close dialog"
      autId="close-dialog-button"
    >
      <cm-icon name="close" />
    </cm-button>
  </div>

  <form [formGroup]="form" class="dialog-content">
    <cm-input-field
      formControlName="sharepointTenantId"
      label="Tenant ID"
      placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
      hint="Your Microsoft Entra (Azure AD) Tenant ID"
      autId="sharepoint-tenant-id-input"
    ></cm-input-field>

    <cm-input-field
      formControlName="clientId"
      label="Client ID"
      placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
      hint="Application (client) ID from your App Registration"
      autId="client-id-input"
    ></cm-input-field>

    <cm-input-field
      formControlName="clientSecret"
      label="Client Secret"
      type="password"
      placeholder="Enter client secret"
      hint="Client secret value from your App Registration"
      autId="client-secret-input"
    ></cm-input-field>

    <cm-input-field
      formControlName="baseUrl"
      label="SharePoint Site URL"
      placeholder="https://your-tenant.sharepoint.com"
      hint="Your SharePoint site base URL (e.g., https://contoso.sharepoint.com)"
      autId="base-url-input"
    ></cm-input-field>

    <div class="automatic-folder-creation">
      <cm-switch
        [ariaLabel]="'Automatic Folder Creation'" formControlName="automaticFolderCreation">
        <div class="switch-content">
          <div class="switch-label">Automatic Folder Creation</div>
          <div class="switch-description">Automatically create document folders for new HR Cases</div>
        </div>
      </cm-switch>
    </div>
  </form>

  <div class="dialog-actions">
    <cm-button
      variant="basic"
      (click)="onCancel()"
      autId="cancel-button"
    >
      Cancel
    </cm-button>
    <cm-button
      variant="flat"
      (click)="onSave()"
      [loading]="state.savingSharepointConfiguration()"
      [disabled]="form.invalid"
      autId="save-button"
    >
      Save
    </cm-button>
  </div>
</div>
